module.exports = __webpack_public_path__ + "img/alipay.67606f86.png";